export enum UserRelation {
  LEGAL_AGREEMENT = 'legal_agreement'
}
